export const SET_REMOVE_WALLET = 'SET_REMOVE_WALLET'
export const SET_RENAME_WALLET = 'SET_RENAME_WALLET'
export const SET_GOOGLE_DRIVE_KEYSTORES = 'SET_GOOGLE_DRIVE_KEYSTORES'
export const SET_SELECTED_WALLET = 'SET_SELECTED_WALLET'

export const setRemoveWallet = data => dispatch =>
  dispatch({
    type: SET_REMOVE_WALLET,
    data,
  })

export const setShowRename = data => dispatch =>
  dispatch({
    type: SET_RENAME_WALLET,
    data,
  })

export const setKeystores = data => dispatch =>
  dispatch({
    type: SET_GOOGLE_DRIVE_KEYSTORES,
    data,
  })

export const setSelectedWallet = data => dispatch =>
  dispatch({
    type: SET_SELECTED_WALLET,
    data,
  })
